import { render, staticRenderFns } from "./otpList.vue?vue&type=template&id=7d9b533d&scoped=true&"
import script from "./otpList.vue?vue&type=script&lang=babel&"
export * from "./otpList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9b533d",
  null
  
)

export default component.exports